import React from "react";
import i18n from "../../../../i18n/i18n";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {withRouter} from "react-router";
import {PackingModel} from "../../../models/packing";
import {PackingService} from "../../../services/packingService";
import PackingForm from "../packingForm/packingForm";

class ModifyPacking extends ModifyItem<PackingModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await PackingService.getPacking(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-packing modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.packing.actions.modifyPacking.header"))}
                    {this.renderContent(<PackingForm isUpdate={true} packingData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyPacking);